import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { buildProfile } from '@tutlo/core'
import { useCallback, useState } from 'react'
import { trackContactCreated } from '../analytics.ts'
import { AskFooter, Shell } from '../layout.tsx'
import { useLead } from '../lead.ts'
import { AccountForm } from '../screens/konto/account-form.tsx'
import { HowItWorksCard } from '../screens/konto/how-it-works.tsx'
import { LoadingAside, LoadingScreen } from '../screens/konto/loading-screen.tsx'
import { ProfileCard } from '../screens/konto/profile-card.tsx'
import { validateSearch } from '../search.ts'

export const Route = createFileRoute('/konto')({
  validateSearch,
  component: AccountRoute,
})

/**
 * Faza 1: „Tworzenie planu” (Figma `153:5691`), faza 2: „Założenie konta” (`278:561`, mobile = prawda, D5).
 * Bez leada → Hook; bez planu → kwalifikator. Lead z e-mailem (powrót) pomija loading.
 */
function AccountRoute() {
  const navigate = useNavigate()
  const lead = useLead()
  const [ready, setReady] = useState(false)
  const onLoaded = useCallback(() => setReady(true), [])

  if (lead.isPending) return <Shell nav={{}}>{null}</Shell>
  if (!lead.data) {
    navigate({ to: '/', replace: true })
    return null
  }
  const plan = lead.data.plan
  if (!plan) {
    navigate({ to: '/q/$slug', params: { slug: lead.data.flowSlug }, replace: true })
    return null
  }
  const showLoading = !ready && !lead.data.email

  if (showLoading) {
    return (
      <Shell nav={{}} footer={<AskFooter />} aside={<LoadingAside />}>
        <LoadingScreen onDone={onLoaded} />
      </Shell>
    )
  }

  const rows = buildProfile(lead.data.quizAnswers, plan)
  return (
    <Shell
      // No way back into the quiz: answers are saved and the screen's only job is the account.
      nav={{}}
      footer={<AskFooter />}
      aside={
        <div className="flex h-full w-full items-center justify-center bg-linear-to-br from-selected-light to-selected-strong px-2xl">
          <HowItWorksCard className="max-w-[603px]" frame="grow" />
        </div>
      }
    >
      <div className="flex flex-col gap-base pt-base pb-base">
        <h1 className="text-h2">Twój plan jest gotowy</h1>
        <ProfileCard rows={rows} />
        <AccountForm
          leadId={lead.data.id}
          initialEmail={lead.data.email}
          initialFirstName={lead.data.firstName}
          onDone={(saved, switched) => {
            // The e-mail belonged to this browser's earlier lead: the API switched the session
            // back to it, so continue in that waiting room instead of booking anew.
            if (switched) {
              void navigate({ to: '/s/$token', params: { token: saved.startToken }, replace: true })
              return
            }
            trackContactCreated(saved)
            void navigate({ to: '/kalendarz' })
          }}
        />
        <HowItWorksCard className="desktop:hidden" frame="grow" />
      </div>
    </Shell>
  )
}
